export default __webpack_public_path__ + "static/media/gableRoofHover.f873eaf6.svg";